<template>
    <div v-if="isAuthenticated">
        <HeroPage v-if="pageData" :data="pageData" heroType="center" vixyFlavorId="0_7uw7ekaf" />

        <PageLayoutBuilder v-if="pageData" :data="pageData" />

        <VideoGridFilterCollection :paging="fetchDataParams.paging"
            :collectionFilter="['Day', 'Session type', 'Speaker']" />
    </div>
    <div v-if="!isAuthenticated">
        <section class="section login whitespace-first-section" v-if="pageData">
            <div class="container">
                <div class="column-wrapper half-half">
                    <div class="column content">
                        <figure>
                            <img class="logo" alt="Logo" src="@/assets/svgs/logo.svg" />
                        </figure>
                        <div class="inner-wrapper">
                            <h1 class="column-title" v-if="pageData.headerTitle && pageData.headerTitle !== ''">
                                {{ pageData.headerTitle }}
                            </h1>
                            <div class="column-txt" v-if="pageData.headerIntroText && pageData.headerIntroText !== ''"
                                v-html="pageData.headerIntroText"></div>

                            <nav class="buttons-wrapper"
                                v-if="pageData.headerButtonUrl && pageData.headerButtonUrl !== '' || pageData.headerSecondButtonUrl && pageData.headerSecondButtonUrl !== ''">
                                <ul class="mini-wrapper">
                                    <li v-if="pageData.headerButtonLabel && pageData.headerButtonLabel !== ''">
                                        <a class="button" :href="pageData.headerButtonUrl" target="_blank">
                                            {{ pageData.headerButtonLabel }}
                                        </a>
                                    </li>
                                    <li v-if="pageData.headerSecondButtonLabel && pageData.headerSecondButtonLabel !== ''">
                                        <a class="button hollow-btn" :href="pageData.headerSecondButtonUrl" target="_blank">
                                            {{ pageData.headerSecondButtonLabel }}
                                        </a>
                                    </li>
                                </ul>
                            </nav>

                            <FaqCollection :filterFaqBy="['Account questions']">
                                <!-- <h2 class="section-title">Frequently asked questions</h2>
                                <span class="section-subtitle">Before you contact us, maybe you can find your answer
                                    here?</span> -->
                            </FaqCollection>
                        </div>
                    </div>
                    <div class="column form popup-looks">
                        <div class="title-wrapper">
                            <h2 class="column-title">Login</h2>
                            <p class="subtitle">Welcome to ANR2023</p>
                        </div>
                        <LoginForm />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// import { fetchMediaList } from "@streampac.io/chef_sp_1";
// @import component
//import HeroVideo from "@/components/HeroVideo";
import HeroPage from "@/components/HeroPage";

// import PricingCta from "@/components/PricingCta";
import PageLayoutBuilder from "@/components/PageLayoutBuilder";
import VideoGridFilterCollection from "@/components/VideoGridFilterCollection";


import LoginForm from "@/components/Forms/LoginForm";
import FaqCollection from "@/components/FaqCollection";

import {
    fetchPageBySlug,
} from "@streampac.io/chef_sp_1";

export default {
    name: "home",
    inject: ["isAuthenticated"],
    metaInfo() {
        return {
            title:
                "Home | ANR2023",
            description:
                "",
        };
    },
    data() {
        return {
            pageData: null,
            fetchDataParams: {
                paging: {
                    pageNumber: 1,
                    pageSize: 6,
                },
            },
        };
    },
    components: {
        //HeroVideo,
        HeroPage,
        PageLayoutBuilder,
        LoginForm,
        FaqCollection,
        VideoGridFilterCollection
    },
    watch: {
        isAuthenticated() {
            this.pageData = null;
            setTimeout(() => {
                this.fetchPage();
            }, 50);
        },
    },
    created() {
        this.fetchPage();
    },
    methods: {
        fetchPage() {
            if (this.isAuthenticated) {
                fetchPageBySlug(this.isAuthenticated, "home").then(
                    (response) => {
                        this.pageData = response;

                        if (response.headerImage && response.headerImage !== '') {
                            let bgUrl = response.headerImageModel.url;
                            this.$store.commit("saveBodyBackgroundUrl", bgUrl);
                        }
                    }
                );
            } else {
                fetchPageBySlug(this.isAuthenticated, "login-page").then(
                    (response) => {
                        this.pageData = response;

                        if (response.headerImage && response.headerImage !== '') {
                            let bgUrl = response.headerImageModel.url;
                            this.$store.commit("saveBodyBackgroundUrl", bgUrl);
                        }
                    }
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>
